import axios, { AxiosResponse } from 'axios';

import { APIError, UnsupportedStructureError } from '~services/Errors';

import { NormaliseEndpointResponseDecoder } from './domain';

export const normalisePhoneNumber = async (phoneNumber: string): Promise<string> => {
  const path = `/api/normalise-phone-number/${phoneNumber}`;
  let resp: AxiosResponse;

  try {
    resp = await axios({
      method: 'GET',
      url: path,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (e) {
    if (axios.isAxiosError(e)) {
      // Response should always be defined if axios error
      throw new APIError(e.response!.status, (e.response!.data as { error: string }).error || e.message);
    }

    throw new APIError(-1, e as string);
  }

  const decoded = NormaliseEndpointResponseDecoder.run(resp.data);

  if (decoded.ok === false) {
    const err = new UnsupportedStructureError(decoded.error.message);

    console.error(decoded.error);
    console.error(err);
    throw err;
  }

  return decoded.result;
};
